module.exports = __webpack_public_path__ + "img/loader.19118ff8.gif";